module.exports = __webpack_public_path__ + "static/media/sb.aa819297.svg";